import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getRefunds = createAsyncThunk(
  "refunds/getRefunds",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", user, owner, filter = {} } = args;
      const filterStr = filterRequest(filter);
      const params = new URLSearchParams();

      if (page) params.append("page", page);
      if (size) params.append("size", size);
      if (query) params.append("search", query);
      if (user) params.append("user", user);
      if (owner) params.append("owner", owner);

      const url = `/refunds${params.toString() ? "?" + params.toString() : ""}${filterStr}`;

      const { data } = await axiosInstance.get(url);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createRefund = createAsyncThunk(
  "refunds/createRefund",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/refunds`, args);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateRefund = createAsyncThunk(
  "refunds/updateRefund",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/refunds/${args._id}`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteRefund = createAsyncThunk(
  "refunds/deleteRefund",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(`/refunds/${args._id}`);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const refundsSlice = createSlice({
  name: "refunds",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getRefunds.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getRefunds.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getRefunds.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createRefund.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createRefund.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createRefund.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateRefund.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateRefund.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(updateRefund.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteRefund.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteRefund.fulfilled, (state) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(deleteRefund.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      });
  },
});

export default refundsSlice.reducer;
